import { FindControlSearchParameterItemDto } from './FindControlSearchParameterItemDto';

export enum FindControlAdditionalSearchParametersType {
  Standard = 'Standard',
  MultipleValues = 'MultipleValues',
}

export class FindControlAdditionalSearchParametersDto {
  Type: FindControlAdditionalSearchParametersType;
  AdditionalSearchParameters: FindControlSearchParameterItemDto[];
}
